<template>
  <div class="ei-star-light">
    <!-- 背景图区域 -->
    <div class="bg-wrap">
      <img :src="WorksListBgImg.url" alt="" class="bg-img bg-img-1" />
      <img :src="HomeStartLightBgImg.url" alt="" class="bg-img bg-img-2" />
    </div>

    <!-- 表头文字 受邀单位 /邀请时间 -->
    <div class="header-row header-left">
      <span class="header-label">受邀单位</span>
      <span class="header-label" style="margin-left: 115px;">邀请时间</span>
      <span class="header-tip">点亮时间三个月内，过期不候</span>
    </div>

    <!-- 左侧滚动列表：未点亮 -->
    <div class="scroll-container scroll-left">
      <ul
        class="scroll-list"
        :style="{ animationDuration: `${duration_noUsed}s` }"
        ref="noUsedDiv"
      >
        <li v-for="(item, index) in allList" :key="index" class="scroll-item">
          <img
            class="item-img"
            :data-src="item.url"
            src=""
            alt=""
            @load="onImgLoad($event, index)"
          />
          <span class="name-text">{{ item.universitiesAndMuseumsName }}</span>
          <span class="time-text">{{ item.invitationTime }}</span>
        </li>
        <!-- 复制一份用于无缝滚动 -->
        <li v-for="(item, index) in allList" :key="`${index}-copy`" class="scroll-item">
          <img
            class="item-img"
            :data-src="item.url"
            src=""
            alt=""
            @load="onImgLoad($event, index)"
          />
          <span class="name-text">{{ item.universitiesAndMuseumsName }}</span>
          <span class="time-text">{{ item.invitationTime }}</span>
        </li>
      </ul>
    </div>

    <!-- 表头文字 点亮圣贤之灯 /点亮时间 -->
    <div class="header-row header-right">
      <span class="header-label">点亮圣贤之灯</span>
      <span class="header-label">点亮时间</span>
    </div>

    <!-- 右侧滚动列表：已点亮 -->
    <div class="scroll-container scroll-right">
      <ul
        class="scroll-list"
        :style="{ animationDuration: `${duration_isUsed}s` }"
        ref="isUsedDiv"
      >
        <li v-for="(item, index) in allList" :key="index" class="scroll-item">
          <img
            class="item-img"
            :data-src="item.url"
            src=""
            alt=""
            @load="onImgLoad($event, index)"
          />
          <span class="name-text">{{ item.universitiesAndMuseumsName }}</span>
          <span class="time-text" v-if="item.isUsed === 1">{{ item.cooperationTime }}</span>
        </li>
        <li v-for="(item, index) in allList" :key="`${index}-copy`" class="scroll-item">
          <img
            class="item-img"
            :data-src="item.url"
            src=""
            alt=""
            @load="onImgLoad($event, index)"
          />
          <span class="name-text">{{ item.universitiesAndMuseumsName }}</span>
          <span class="time-text" v-if="item.isUsed === 1">{{ item.cooperationTime }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { queryStarLightList, queryWorksAttachByTargetInfo } from '@/api/reception/works-api'
import { isFailure } from '@/eiuov-utils/axios/response'

export default {
  name: 'EiStarLight',
  props: {
    speed: {
      type: Number,
      default: 100
    }
  },
  data() {
    return {
      HomeStartLightBgImg: {},
      WorksListBgImg: {},
      duration_noUsed: 0,
      duration_isUsed: 0,
      noUsedList: [],
      isUsedList: [],
      allList: [],
      // 记录哪些图片已经加载完成，避免重复赋值src
      loadedImgSet: new Set()
    }
  },
  mounted() {
    // 组件挂载后，首次加载可视区域图片
    this.lazyLoadImages()
    // 滚动动画是CSS，这里用定时器轮询检测图片是否进入视口；
    // 因为是CSS transform滚动，scroll事件不会触发，只能轮询
    this.imgTimer = setInterval(() => {
      this.lazyLoadImages()
    }, 300)
  },
  beforeDestroy() {
    clearInterval(this.imgTimer)
  },
  created() {
    queryStarLightList({ query: '' }).then((res) => {
      if (isFailure(res)) return
      this.isUsedList = res.data.isUsedList
      this.noUsedList = res.data.noUsedList
      this.allList = res.data.allList
    })
    queryWorksAttachByTargetInfo({ targetGuid: 'HomeStartLightBgImg' }).then((res) => {
      if (isFailure(res)) return
      this.HomeStartLightBgImg = res.data.worksAttach
    })
    queryWorksAttachByTargetInfo({ targetGuid: 'WorksListBgImg3' }).then((res) => {
      if (isFailure(res)) return
      this.WorksListBgImg = res.data.worksAttach
    })
  },
  updated() {
    this.initKeyframes_noUsed()
    this.initKeyframes_isUsed()
  },
  methods: {
    initKeyframes_noUsed() {
      const dom = this.$refs.noUsedDiv
      if (!dom) return
      const textHeight = dom.offsetHeight
      const startY = -textHeight
      const endY = 50
      this.duration_noUsed = (endY - startY) / this.speed
    },
    initKeyframes_isUsed() {
      const dom = this.$refs.isUsedDiv
      if (!dom) return
      const textHeight = dom.offsetHeight
      const startY = -textHeight
      const endY = 50
      this.duration_isUsed = (endY - startY) / this.speed
    },
    // 手动懒加载核心：判断图片是否进入视口
    lazyLoadImages() {
      const imgs = document.querySelectorAll('.item-img')
      imgs.forEach((imgEl) => {
        const srcReal = imgEl.dataset.src
        if (!srcReal || this.loadedImgSet.has(srcReal)) return

        const rect = imgEl.getBoundingClientRect()
        // 判断元素是否在视口上下一定缓冲范围内
        const isView = rect.bottom > -200 && rect.top < window.innerHeight + 200
        if (isView) {
          imgEl.src = srcReal
        }
      })
    },
    onImgLoad(evt, idx) {
      // 标记图片加载完毕
      const src = evt.target.dataset.src
      this.loadedImgSet.add(src)
    }
  }
}
</script>

<style lang="scss" scoped>
.ei-star-light {
  position: relative;
  width: 1600px;
  height: 490px;
  overflow: hidden;
}

.bg-wrap {
  position: absolute;
  inset: 0;
  .bg-img {
    position: absolute;
    inset: 0;
    width: 100%;
    height: 100%;
    &.bg-img-2 {
      animation: worksBg4 2s linear infinite;
    }
  }
}

@keyframes worksBg4 {
  to {
    filter: hue-rotate(360deg);
  }
}

// 表头公共
.header-row {
  position: absolute;
  display: flex;
  // 表头文字贴行首：原 align-items:center 时，左侧两个表头会被 360px 高的竖排提示
  // 拉到垂直中间（y 约 200px，压在列表内容上），旧实现里它们是在 y=40 的列表上方
  align-items: flex-start;
  gap: 40px;
  z-index: 2;
  .header-label {
    font-size: 26px;
    font-weight: bold;
    color: #adb5bd;
    opacity: 0.5;
    letter-spacing: 4px;
  }
  .header-tip {
    font-size: 22px;
    letter-spacing: 6px;
    color: #adb5bd;
    opacity: 0.8;
    filter: brightness(80%);
    writing-mode: vertical-lr;
    // 去掉固定 360px 高度并禁止换行：13 个字约需 364px，原高度会把末字"候"折到第二列
    white-space: nowrap;
  }
}
.header-left {
  top: 40px;
  left: 40px;
}
.header-right {
  top: 40px;
  left: 860px;
  .header-label {
    color: #000;
    opacity: 1;
  }
}

// 滚动容器
.scroll-container {
  position: absolute;
  width: 300px;
  height: 330px;
  overflow: hidden;
  top: 85px;

  &.scroll-left {
    left: 40px;
    width: 720px;
  }
  &.scroll-right {
    left: 860px;
    width: 720px;
  }

  .scroll-list {
    list-style: none;
    margin: 0;
    padding: 0;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-play-state: running;

    &:hover {
      animation-play-state: paused;
    }
  }

  .scroll-item {
    display: flex;
    align-items: center;
    height: 50px;
    line-height: 50px;
    gap: 20px;

    .item-img {
      width: 45px;
      flex-shrink: 0;
      & {
        opacity: 0.5;
        filter: opacity(0.5);
      }
    }
    .name-text {
      font-size: 24px;
      font-weight: bold;
      color: #adb5bd;
      letter-spacing: 2px;
      flex: 0 0 220px;
    }
    .time-text {
      font-size: 24px;
      font-weight: bold;
      color: #adb5bd;
      letter-spacing: 2px;
      flex: 1;
    }
  }
}

// 左侧列表动画
.scroll-left .scroll-list {
  animation-name: scrollLeftAnim;
}
@keyframes scrollLeftAnim {
  0% {
    transform: translateY(0px);
  }
  100% {
    transform: translateY(-50%);
  }
}

// 右侧列表动画
.scroll-right .scroll-list {
  animation-name: scrollRightAnim;
}
@keyframes scrollRightAnim {
  0% {
    transform: translateY(0px);
  }
  100% {
    transform: translateY(-50%);
  }
}
</style>
